import { BRANCH_API, PAYMENT_GATEWAY_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { PaymentGatewayModel } from "./payment-gateway.models";

export const getPaymentGatewayList = async () => {
  const createResponse = await apiClient.getHttp<PaymentGatewayModel[]>(
    `${PAYMENT_GATEWAY_API}`
  );
  return createResponse;
};

export const getBranchPaymentSetting = async (
  branchId: number,
  paymentGatewayCode: string
) => {
  const createResponse = await apiClient.getHttp<any>(
    `${BRANCH_API}/${branchId}/payment_settings/${paymentGatewayCode}`
  );
  return createResponse;
};

export const updateBranchPaymentSetting = async (
  branchId: number,
  paymentGatewayCode: string,
  model: any
) => {
  const createResponse = await apiClient.putHttp(
    `${BRANCH_API}/${branchId}/payment_settings/${paymentGatewayCode}`,
    model
  );
  return createResponse;
};
